<template>
    <v-container>
        <v-row class="text-center">
            <v-col cols="12">

                <v-btn x-large elevation="14" style="height: 72px;">
                    <v-card-title @click="getCompliment">
                        <h1 style="text-transform: none">UwU</h1>
                    </v-card-title>
                </v-btn>
                <div class="text-h3">{{ compliment.text }}</div>
            </v-col>
        </v-row>
    </v-container>
</template>

<style scoped>
    .text-h3 {
        margin-top: 10px;
    }
</style>

<script>
import axios from 'axios';

export default {
    name: 'ComplimentView',

    data: () => ({
        compliment: '',
    }),
    methods: {
        async getCompliment() {
            await axios.get('/api/compliment/random/').then(response => this.compliment = response.data);
        },
    }

}
</script>
